<template>
  <div v-bind="$attrs">
   <Topheader />
   <Not />
   <Suc />
   <div class="contentblock">
    <Suspense>
          <slot />
    </Suspense>
   </div>
   <transition name="slimeright">
                   <slotokno :close="() => closeOknoComponent()" :text="'Закрыть'" v-if="viewOknoComponent.view">
                    <Suspense>
                    <component :is="viewOknoComponent.component" />
                    </Suspense>
                  </slotokno>
   </transition>


   <transition name="slimeright">
                   <basketviewokno v-if="viewbasket" :key="Date.now()"/>
   </transition>
   <transition name="slimeright">
                   <slotokno :close="() => oknoUser(false)" :text="'Профиль'" v-if="viewUser.view"><clientmenu /></slotokno>
   </transition>
   <pwa />

   <transition name="opacity">
        <modalokno 
            :close="() => closeOknoProfile()" 
            :text="`Заполните профиль`" 
            :button="'сохранить'"
            :func="closeOknoProfile"
            v-if="oknoNewClient"
        >
        <oknonewclient />
      </modalokno>
    </transition>

  </div>

</template>

<script setup>
import Topheader from '@/components/general/topheader.vue'
import Not from '@/components/general/not.vue'
import Suc from '@/components/general/suc.vue'
import { viewOknoComponent, closeOknoComponent } from '@/controlles/general'
import { viewUser, oknoUser } from '@/controlles/client'
import clientmenu from '@/components/client/clientmenu.vue'
import { connectSse } from '@/sse'
import basketviewokno from '@/components/client/basket.vue'
import { viewbasket } from '@/controlles/basket/basket'
import pwa from '@/components/general/pwa.vue'
connectSse()

import { notSet } from '@/controlles/general'
import { oknoNewClient,saveUser,client } from '@/controlles/client'
import oknonewclient from '@/components/client/oknonewclient.vue'

const closeOknoProfile = async () => {
      if (client.value.firstname == null || client.value.firstname.trim() == 0) {
        return notSet('Заполните обязательные поля')
      }
      await saveUser()
      oknoNewClient.value = false

}

</script>

<style scoped>

.contentblock{
    width: 90%;
    margin: 20px auto 0px;
    padding-top: 60px;
    padding-bottom: 60px;
}

</style>
